import { rupiah } from "../../lib/api";
import { PhotoSlider } from "../PhotoSlider";
import { BuyButtons } from "./BuyButtons";

export const ProductCard = ({ product, onOpen, index, whatsapp }) => (
  <div onClick={() => onOpen(product)} data-testid={`public-product-card-${product.product_id}`}
    className="group cursor-pointer overflow-hidden rounded-2xl border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(15,23,42,0.08)] fade-up"
    style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}>
    <PhotoSlider photos={product.photos} interval={2800 + (index % 4) * 300} testId={`card-slider-${product.product_id}`} />
    <div className="p-3 sm:p-4">
      <p className="line-clamp-2 min-h-[2.5rem] text-sm font-semibold text-slate-900" data-testid={`public-product-name-${product.product_id}`}>{product.name}</p>
      <div className="mt-1 flex flex-wrap items-baseline gap-x-1.5">
        <span className="font-bold text-slate-900">{rupiah(product.price)}</span>
        {product.original_price > 0 && <span className="text-xs text-slate-400 line-through">{rupiah(product.original_price)}</span>}
      </div>
      <div className="mt-3"><BuyButtons product={product} whatsapp={whatsapp} /></div>
    </div>
  </div>
);
